import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import PowerWashingProposalBuilder from "@/pages/PowerWashingProposalBuilder";
export const Route = createFileRoute("/power-washing-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="power-washing"><PowerWashingProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
